export default "__VITE_ASSET__DoadToyN__"